export default __webpack_public_path__ + "static/media/checkMark.db540abd.svg";